export function getAuthErrorMessage(code) {
  switch (code) {
    case 'auth/invalid-credential':
      return 'Incorrect email or password. Please try again.'
    case 'auth/wrong-password':
      return 'Incorrect password. Please try again.'
    case 'auth/user-not-found':
      return 'No account found with this email address.'
    case 'auth/invalid-email':
      return 'Please enter a valid email address.'
    case 'auth/email-already-in-use':
      return 'An account with this email already exists.'
    case 'auth/weak-password':
      return 'Password must be at least 6 characters.'
    case 'auth/user-disabled':
      return 'This account has been disabled. Please contact support.'
    case 'auth/too-many-requests':
      return 'Incorrect password has been used too many times. Please try again later or reset your password.'
    case 'auth/network-request-failed':
      return 'Network error. Please check your connection and try again.'
    case 'auth/popup-closed-by-user':
      return 'Sign-in popup was closed before completing. Please try again.'
    case 'auth/popup-blocked':
      return 'Sign-in popup was blocked by your browser. Please allow popups and try again.'
    case 'auth/account-exists-with-different-credential':
      return 'An account already exists with the same email but a different sign-in method.'
    case 'auth/requires-recent-login':
      return 'Please log out and log back in before performing this action.'
    case 'auth/expired-action-code':
      return 'This link has expired. Please request a new one.'
    case 'auth/invalid-action-code':
      return 'This link is invalid or has already been used.'
    default:
      return 'An unexpected error occurred. Please try again.'
  }
}
